import { render, staticRenderFns } from "./TabLogImport.vue?vue&type=template&id=ad5b97d8&"
import script from "./TabLogImport.vue?vue&type=script&lang=js&"
export * from "./TabLogImport.vue?vue&type=script&lang=js&"
import style0 from "./TabLogImport.vue?vue&type=style&index=0&id=ad5b97d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports